module.exports = __webpack_public_path__ + "img/growcify-mini-banner-2.fe957ba1.png";